import { render, staticRenderFns } from "./AssetListAddNew.vue?vue&type=template&id=5e2bf703"
import script from "./AssetListAddNew.vue?vue&type=script&lang=js"
export * from "./AssetListAddNew.vue?vue&type=script&lang=js"
import style0 from "./AssetListAddNew.vue?vue&type=style&index=0&id=5e2bf703&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports